import { useCallback, useState } from 'react';

import type { BREAKPOINTS } from '@/constants';

import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

/**
 * @deprecated
 */
export const LEGACY_BREAKPOINTS = {
  MOBILE: '(max-width: 767px)',
  TABLET: '(min-width: 768px) and (max-width: 1023px)',
  DESKTOP: '(min-width: 1024px)',
} as const;

type BreakpointType = (typeof BREAKPOINTS)[keyof typeof BREAKPOINTS];

/**
 * 미디어 쿼리 상태를 추적하는 커스텀 훅
 * @param query - 미디어 쿼리 문자열 또는 미리 정의된 브레이크포인트
 * @param defaultValue - SSR 환경에서 사용할 기본값 (기본값: false)
 * @returns 현재 미디어 쿼리 매치 상태
 */
export const useMediaQuery = (
  query: BreakpointType | string,
  defaultValue = false,
): boolean => {
  // SSR 호환성을 위해 초기값을 defaultValue로 통일
  const [matches, setMatches] = useState(defaultValue);

  const handleChange = useCallback((event: MediaQueryListEvent) => {
    setMatches(event.matches);
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    const media = window.matchMedia(query);

    setMatches(media.matches);

    media.addEventListener('change', handleChange);

    return () => media.removeEventListener('change', handleChange);
  }, [query, handleChange]);

  return matches;
};
